import { createAsyncThunk } from "@reduxjs/toolkit";
import type { ServiceStatusGroup } from "types";
import { apiGet } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const fetchServiceStatuses = createAsyncThunk(
	"serviceStatuses/fetch",
	apiGet<ServiceStatusGroup[]>(
		(authConfig) => authConfig.FRESHSERVICE_API_ENDPOINTS.GET_SERVICE_STATUSES(),
		[SCOPES.FRESHSERVICE_READ],
	),
);
